import { nbsp } from '@ipfabric/frontend-shared-assets/utils/characters';
import type { RateLimitationSettings } from '@ipfabric/utils';
import {
  maxCapacity,
  maxConcurrentRequests,
  refillRate,
  refillRateIntervalMs,
} from '@ipfabric/utils/settings/vendorApi/defaults/base';
import { FormikTextField } from 'components/FormikTextField/FormikTextField';
import { useLocale } from 'containers/App/LocaleContext';
import type { FormikProps } from 'formik';
import type { JSX } from 'react';

interface Props<T extends RateLimitationSettings> {
  formik: FormikProps<T>;
}

export const FormikRateLimitingSettingsFields = <
  T extends RateLimitationSettings,
>(
  props: Props<T>,
): JSX.Element => {
  const msg = useLocale();

  return (
    <>
      <div className='mt-4'>
        <FormikTextField
          formik={props.formik}
          label={msg.discoverySettings.vendorsApi.labels.maxConcurrentRequests}
          name='maxConcurrentRequests'
          type='number'
          className='w-24'
          {...maxConcurrentRequests.boundaryValues}
        />
        <div className='flex items-center gap-2'>
          <FormikTextField
            formik={props.formik}
            label={msg.discoverySettings.vendorsApi.labels.maxCapacity}
            name='maxCapacity'
            type='number'
            className='w-24'
            {...maxCapacity.boundaryValues}
          />
          <span className='font-semibold'>
            {msg.discoverySettings.vendorsApi.rateLimitingSettings.requests}
          </span>
        </div>
        <div className='flex gap-3'>
          <div className='flex items-center gap-2'>
            <FormikTextField
              formik={props.formik}
              label={msg.discoverySettings.vendorsApi.labels.refillRate}
              name='refillRate'
              type='number'
              className='w-24'
              {...refillRate.boundaryValues}
            />
            <span className='w-20 font-semibold'>
              {
                msg.discoverySettings.vendorsApi.rateLimitingSettings
                  .requestsPer
              }
            </span>
          </div>
          <div className='flex items-center gap-2'>
            <FormikTextField
              formik={props.formik}
              label={nbsp}
              name='refillRateIntervalMs'
              type='number'
              className='w-24'
              {...refillRateIntervalMs.boundaryValues}
            />
            <span className='font-semibold'>
              {
                msg.discoverySettings.vendorsApi.rateLimitingSettings
                  .milliseconds
              }
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
